import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { AsYouType } from 'libphonenumber-js'
import omit from 'lodash/omit'

function PhoneInput(props) {
  const [value, setValue] = useState(props.value)

  useEffect(() => {
    setValue(props.value !== '' ? formattedPhone(props.value) : props.value)
  }, [props.value])

  const formatter = new AsYouType(props.country.iso2.toUpperCase())

  const formattedPhone = phone => {
    formatter.reset()
    return formatter.input(phone)
  }

  const handleFocus = () => {
    setValue(formattedPhone(value))
  }

  return <input {...omit(props, ['value', 'country'])} value={formattedPhone(value)} onFocus={handleFocus} type="tel" />
}

PhoneInput.propTypes = {
  value: PropTypes.string
}

PhoneInput.defaultProps = {
  value: null
}

export default PhoneInput
